import React from 'react';
import ReportingFinancesRefundsPage from '../components/ReportingFinancesRefundsPage';

const ReportingFinancesRefundsApp = (props) => (
  <ReportingFinancesRefundsPage {...props} />
);

export default ReportingFinancesRefundsApp;
